import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SetSquareIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M7.88 3.68a8.15 8.15 0 0 0-4.67 5.6h.01A2.86 2.86 0 0 0 6 12.82h15.1c1.06 0 1.91.86 1.91 1.92v6.59c0 .93-.75 1.68-1.68 1.68h-3.84a1 1 0 0 1-.06 0H8.38a1 1 0 0 1-.06 0H5.5A4.5 4.5 0 0 1 1 18.5v-7.37a10.13 10.13 0 0 1 20.25 0h-2c0-3.33-2-6.2-4.87-7.45.1.2.19.4.27.62.72 1.8 1.15 4.21 1.15 6.83h-2c0-2.43-.4-4.57-1-6.08-.3-.76-.65-1.3-.97-1.64-.32-.34-.56-.41-.7-.41-.15 0-.39.07-.7.4-.33.35-.67.9-.97 1.65a17 17 0 0 0-1 6.08h-2c0-2.62.42-5.03 1.14-6.83l.28-.62Zm1.47 12.87V21h2.56v-2.64a1 1 0 1 1 2 0V21h2.54v-4.45a1 1 0 0 1 2 0V21H21v-6.18H6a4.83 4.83 0 0 1-3-1.03v4.71A2.5 2.5 0 0 0 5.5 21h1.85v-4.45a1 1 0 0 1 2 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default SetSquareIcon;
